module.exports = __webpack_public_path__ + "static/media/Lotto6.c024618d.png";